//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DescriptionCard from '~/components/forGaming/DescriptionCard.vue'
import DescriptionBlock from '~/components/forCompanies/DescriptionBlock.vue'
import TopScreen from '~/components/TopScreen.vue'
import FooterTop from '~/components/footer/footerTop.vue'
import ListBlock from '~/components/forGaming/ListBlock.vue'
import ContainerBox from '~/components/common/ContainerBox.vue'
import FeatureContainer from '~/components/forCompanies/FeatureContainer.vue'
import AnimatedLink from '~/components/common/AnimatedLink.vue'

export default {
  components: {
    TopScreen,
    DescriptionCard,
    FooterTop,
    ListBlock,
    ContainerBox,
    DescriptionBlock,
    FeatureContainer,
    AnimatedLink
  },
  head () {
    return {
      title: this.$t('footer.solutions.our-solutions').concat(' | Pagsmile '),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  }
}
